import * as React from 'react';
import { Tag } from '@grandvisionhq/common';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const ProductLabelTag = ({ className  })=>{
    var ref;
    const { activeVariant  } = useProductDetailContext();
    if (!((ref = activeVariant.tag) === null || ref === void 0 ? void 0 : ref.value) || typeof activeVariant.tag.value !== 'string') {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Tag, {
        className: className,
        iconKey: activeVariant.tag.key,
        label: activeVariant.tag.value
    });
};

export { ProductLabelTag };
//# sourceMappingURL=ProductLabelTag.js.map
